export default __webpack_public_path__ + "static/media/pictorial.70706bea.svg";